module.exports = __webpack_public_path__ + "static/Metal Roof and Siding - Cladding-c36ffc500f9c1f191fbb930195b850b1.jpg";